import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { getCurrentUser } from '../../publicSession/selectors';
import { getCurrentItem } from '../../Duperbrowse/redux/selectors';
import {
  BiContextProvidedValue,
  BiData,
  ExternalLinkClick,
} from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../types/resource';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';

export function useSafeUrlHandler() {
  const dispatch = useDispatch();
  const currentUser = useSelector(getCurrentUser);
  const currentDeviation = useSelector(getCurrentItem);
  const logBiEvent = useBiLogger();

  const safeUrlHandler = useCallback(
    e => {
      if (currentUser.userId === currentDeviation?.author?.userId) {
        return;
      }
      const clickedEl = e.target;

      // Closest is inclusive of the target, and should be safe as
      // we cant have anchor inside anchor.
      const anchor = (clickedEl as HTMLElement).closest('a');
      if (anchor) {
        let href = anchor.getAttribute('href') ?? '';
        href = href.replace(
          /^https?:\/\/www\.deviantart\..*\/users\/outgoing\?/i,
          ''
        );
        if (
          !/^https?:\/\/.*deviantart\..*\//.test(href) &&
          !/^https?:\/\/.*sta\.sh/.test(href) &&
          !/^https?:\/\/.*dreamup\.com\.\..*\//.test(href) &&
          !/^https?:\/\/.*deviantartsell\.com/.test(href) &&
          !/^https?:\/\/.*deviantartsupport\.com/.test(href) &&
          !/^https?:\/\/.*fav\.me/.test(href) &&
          !/^#/.test(href)
        ) {
          e.preventDefault();
          e.stopPropagation();
          logBiEvent(
            BiData<ExternalLinkClick>({
              evid: 364,
              link_url: href,
              sectionname: BiContextProvidedValue,
              itemid: currentDeviation?.deviationId ?? 0,
              typeid: ResourceType.DEVIATION,
            })
          );
          dispatch(
            pushModal(ModalType.SAFE_URL, {
              params: { href },
              wrapInModal: false,
            })
          );
        }
      }
    },
    [
      currentDeviation?.author?.userId,
      currentDeviation?.deviationId,
      currentUser?.userId,
      dispatch,
      logBiEvent,
    ]
  );

  return safeUrlHandler;
}
